import React from "react";
import CustomTabsGrid from "components/CustomTabs/CustomTabsGrid.js";
import Maubaocao19 from "components/Tonghopbaocao/Maubaocao19/Maubaocao19.js";
export default function BCmau19() {
  return (
    <div>
      <CustomTabsGrid
        headerColor="primary"
        tabs={[
          {
            tabName: "Kết quả hoạt động vận chuyển hàng hóa (Phụ lục XV)",
            tabContent: <Maubaocao19 />,
          },
        ]}
      />
    </div>
  );
}
